var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-cascader',{staticClass:"width-200",attrs:{"options":_vm.orgOptions,"props":{checkStrictly: true},"clearable":"","placeholder":"所有部门"},on:{"change":_vm.changeFn},model:{value:(_vm.orgId),callback:function ($$v) {_vm.orgId=$$v},expression:"orgId"}})
}
var staticRenderFns = []

export { render, staticRenderFns }